export interface PickerToken {
  symbol: string
  chainIds: number[]
}

export interface PickerChain {
  id: string
  name: string
  iconUri?: string
}

export interface PickerSelection {
  symbol: string
  chainId: number
}

export function pickerChainForToken(
  tokens: PickerToken[],
  chains: PickerChain[],
  symbol: string,
  preferred?: number,
): number | undefined {
  const supported =
    tokens.find((token) => token.symbol === symbol)?.chainIds ?? []
  const compatible = chains.filter((chain) =>
    supported.includes(Number(chain.id)),
  )
  const chain =
    compatible.find((entry) => Number(entry.id) === preferred) ?? compatible[0]
  return chain ? Number(chain.id) : undefined
}
